<script>
import { BImgLazy } from "bootstrap-vue";

export default {
  extends: BImgLazy
};
</script>